export default __webpack_public_path__ + "static/toggl-track-features-f539de22b1b8d9453b58c82ed9b3937d.jpg";